
import PlanProduct from '@/views/eduplanmap/PlanProduct'
import MyPlan from '@/views/eduplanmap/MyPlan'
import PlanReg from '@/views/eduplanmap/PlanReg'
import Cart from '@/views/eduplanmap/Cart'
import Promotion from '@/views/eduplanmap/Promotion'
import OrgList from '@/views/eduplanmap/OrgList'

export default [
    {
        path: '/eduplanmap',
        name: 'plan-product',
        component: PlanProduct,
        meta: { auth: true,
            logging: true,
            pageName: '에듀플랜맵' }
    },
    {
        path: '/eduplanmap/myPlan',
        name: 'my-plan',
        component: MyPlan,
        meta: { auth: true,
            logging: true,
            pageName: '나만의 플랜' }
    },
    {
        path: '/eduplanmap/planReg',
        name: 'plan-regist',
        component: PlanReg,
        meta: { auth: true,
            logging: true,
            pageName: '나만의 플랜 등록' }
    },
    {
        path: '/eduplanmap/cart',
        name: 'cart',
        component: Cart,
        meta: { auth: true,
            logging: true,
            pageName: '에듀플랜맵 장바구니' }
    },
    {
        path: '/eduplanmap/promotion',
        name: 'promotion',
        component: Promotion,
        meta: { auth: true,
            logging: true,
            pageName: '프로모션' }
    },
    {
        path: '/eduplanmap/orgList',
        name: 'orgList',
        component: OrgList,
        meta: { auth: true,
            logging: true,
            pageName: '에듀플랜맵-조직팝업' }
    },
]